/** Mockup display vocabulary keyed by the domain's own status and kind unions. */
import type { AgentKind, AgentStatus } from './types';

/** Success-figure colour, shared by the card grid, the heatmap rows and the detail header. */
export const SUCC_COLOR: Record<AgentStatus, string> = {
  ok: 'var(--cc-ok)',
  warn: 'var(--cc-warn)',
  crit: 'var(--cc-crit)',
  idle: 'var(--cc-muted)',
};

/** The type chip's wording, on the card and in the detail meta row. */
export const KIND_LABEL: Record<AgentKind, string> = {
  ai: 'AI agent',
  auto: 'automation',
  planned: 'planned',
  loop: 'loop',
};
